$(document).ready(() => {
  slickCollectionButton();
  
  function slickCollectionButton() {
    const $ele = $('.collection-button-list');
    if ($ele.length && $(window).width() < 768) {
      $ele.each(function () {
        var self = $(this);
        self.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          infinite: false,
          speed: 800,
          autoplay: false,
          variableWidth: true,
          focusOnSelect: true,
          swipeToSlide: true
        });
      })
    }
  }
})